@if (messageText(); as message) {
  <app-alert-toast severity="error" [message]="message" live="assertive" />
}
